import React, {useEffect, useState} from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  CircularProgress,
  MenuItem,
  TextField,
  FormLabel,
  Button,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import useReduxState from '../../core/useReduxState';
import api from '../../core/api';
import ReturnButton from '../ReturnButton';
import {FieldArray, Formik, getIn} from 'formik';
import ButtonSubmit from './ButtonSubmit';
import request from 'superagent';
import AccordionItem, {AccordionCustom, PlansForm} from '../AccordionItem';
import * as Yup from 'yup';
import {formatDate} from '../../utils/formatDate';
import EditorComponent from '../../pages/newsletter/components/ComponentEditorJs';
import Business from '../../models/Business';

const validationSchema = Yup.object().shape({
  clientCode: Yup.string()
    .nullable()
    .notRequired(),
  corporateName: Yup.string().required('Razão Social é obrigatória'),
  tradeName: Yup.string().required('Nome Fantasia é obrigatório'),
  clientDocument: Yup.string().required('CPF ou CNPJ é obrigatório'),
  groupCompanies: Yup.array().of(
    Yup.object().shape({
      id: Yup.number()
        .nullable()
        .notRequired(),
      corporateName: Yup.string()
        .nullable()
        .notRequired(),
    }),
  ),

  address: Yup.object().shape({
    street: Yup.string().required('Logradouro é obrigatório'),
    number: Yup.string().required('Número é obrigatório'),
    neighborhood: Yup.string().required('Bairro é obrigatório'),
    complement: Yup.string()
      .nullable()
      .notRequired(),
    city: Yup.string().required('Cidade é obrigatória'),
    state: Yup.string().required('Estado é obrigatório'),
    country: Yup.string().required('País é obrigatório'),
    postalCode: Yup.string().required('CEP é obrigatório'),
  }),

  clientType: Yup.string().required('Tipo de cliente é obrigatório'),
  customerSize: Yup.string()
    .nullable()
    .required('Porte do cliente é obrigatório'),
  activityBranch: Yup.string().required('Ramo de atividade é obrigatório'),
  site: Yup.string()
    .nullable()
    .notRequired(),
  midia_1: Yup.string()
    .nullable()
    .notRequired(),
  midia_2: Yup.string()
    .nullable()
    .notRequired(),
  midia_3: Yup.string()
    .nullable()
    .notRequired(),
  midia_4: Yup.string()
    .nullable()
    .notRequired(),
  clientObservation: Yup.string()
    .nullable()
    .notRequired(),
  headquarterCNPJ: Yup.string()
    .nullable()
    .notRequired(),

  contacts: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required('Nome do contato é obrigatório'),
        nickname: Yup.string()
          .nullable()
          .notRequired(),
        department: Yup.string().required('Departamento é obrigatório'),
        role: Yup.string()
          .nullable()
          .notRequired(),
        email: Yup.string()
          .email('E-mail inválido')
          .required('E-mail é obrigatório'),
        emailLogin: Yup.string()
          .email('E-mail para login inválido')
          .required('E-mail para login é obrigatório'),
        phone1: Yup.string().required('Telefone 1 é obrigatório'),
        phone2: Yup.string()
          .nullable()
          .notRequired(),
        whatsapp: Yup.string().required('Whatsapp é obrigatório'),
        cpf: Yup.string()
          .nullable()
          .notRequired(),
        rg: Yup.string()
          .nullable()
          .notRequired(),
        street: Yup.string()
          .nullable()
          .notRequired(),
        number: Yup.string()
          .nullable()
          .notRequired(),
        neighborhood: Yup.string()
          .nullable()
          .notRequired(),
        city: Yup.string()
          .nullable()
          .notRequired(),
        state: Yup.string()
          .nullable()
          .notRequired(),
        country: Yup.string()
          .nullable()
          .notRequired(),
        postalCode: Yup.string()
          .nullable()
          .notRequired(),
        contactObservation: Yup.string()
          .nullable()
          .notRequired(),
      }),
    )
    .min(1, 'Pelo menos um contato deve ser preenchido'),

  clientStatus: Yup.string()
    .nullable()
    .notRequired(),
  plans: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string()
          .nullable()
          .notRequired(),
        beneficiaryType: Yup.string()
          .nullable()
          .notRequired(),
        commercialNotes: Yup.string()
          .nullable()
          .notRequired(),
        additionalServices: Yup.string()
          .nullable()
          .notRequired(),
        status: Yup.string()
          .nullable()
          .notRequired()
          .default('Inactive'),
        planDate: Yup.string()
          .nullable()
          .notRequired(),
        valueFull: Yup.string()
          .nullable()
          .notRequired(),
        value: Yup.string()
          .nullable()
          .notRequired(),
        discount: Yup.string()
          .nullable()
          .notRequired(),
        percentageDiscount: Yup.string()
          .nullable()
          .notRequired(),
        validity: Yup.string()
          .nullable()
          .notRequired(),
        paymentMethod: Yup.string()
          .nullable()
          .notRequired(),
        // .required('Forma de pagamento é obrigatória',),
        billingType: Yup.string()
          .nullable()
          .notRequired(),
        // .required('Tipo de faturamento é obrigatório'),
        invoiceIssueDate: Yup.string()
          .nullable()
          .notRequired(),
        // .required( 'Data de emissão da NF é obrigatória', ),
        dueDate: Yup.string()
          .nullable()
          .notRequired(),
        // .required('Data de vencimento é obrigatória'),
        billingRules: Yup.string()
          .nullable()
          .notRequired(),
        paymentHistory: Yup.string()
          .nullable()
          .notRequired(),
        financialObservation: Yup.string()
          .nullable()
          .notRequired(),
      }),
    )
    .min(1, 'Pelo menos um plano deve ser preenchido'),

  contractNumber: Yup.string().required('Número do contrato é obrigatório'),
  contractStatus: Yup.string().required('Status do contrato é obrigatório'),
  contractSignatureDate: Yup.string().required('Data é obrigatória'),
  contractLastChangeDate: Yup.string().required('Data é obrigatória'),
  contractValidityDate: Yup.string().required('Data é obrigatória'),
  contractAdjustmentConditions: Yup.string()
    .nullable()
    .notRequired(),
  contractLateFees: Yup.string()
    .nullable()
    .notRequired(),
  contractDocumentLink: Yup.string()
    .nullable()
    .notRequired(),
  contractObservation: Yup.string()
    .nullable()
    .notRequired(),
  crm: Yup.string()
    .nullable()
    .notRequired(),
});

export const getviaCepUrl = (postal_code = '', handleFormikValues) => {
  const cepWithoutHifen = postal_code.replace(/-/g, '');
  if (cepWithoutHifen.length === 8) {
    let next_address = request.get(
      `https://viacep.com.br/ws/${postal_code}/json`,
    );
    next_address.end((err, response) => {
      if (err) {
        console.log(err);
      } else {
        console.log(' response.body', response.body);
        if (response.body) {
          const {logradouro, cep, localidade, bairro, uf} = response.body;
          handleFormikValues.setFieldValue('address.postalCode', cep);
          handleFormikValues.setFieldValue('address.street', `${logradouro}`);
          handleFormikValues.setFieldValue('address.city', localidade);
          handleFormikValues.setFieldValue('address.state', uf);
          handleFormikValues.setFieldValue('address.neighborhood', bairro);
          handleFormikValues.setFieldValue('address.country', 'Brasil');
        }
      }
    });
  }
};

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  label: {
    paddingTop: 30,
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '50%',
    height: '100px',
    marginRight: 50,
  },
  pLeft: {paddingLeft: '15px'},
}));
const BusinessForm = ({
  business = {
    clientCode: '',
    corporateName: '',
    tradeName: '',
    clientDocument: '',
    address: {
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
    },
    clientType: '',
    customerSize: '',
    activityBranch: '',
    site: '',
    midia_1: '',
    midia_2: '',
    midia_3: '',
    midia_4: '',
    clientObservation: '',

    // Contacts
    contacts: [],

    // Comercial
    clientStatus: '',
    plans: [
      {title: 'Plano Mensal 1', planType: 'M'},
      {title: 'Plano Mensal 2', planType: 'M'},
      {title: 'Plano Mensal 3', planType: 'M'},
      {title: 'Plano Anual 1', planType: 'Y'},
      {title: 'Plano Anual 2', planType: 'Y'},
      {title: 'Plano Anual 3', planType: 'Y'},
      {title: 'Plano Special 1', planType: 'S'},
      {title: 'Plano Special 2', planType: 'S'},
      {title: 'Plano Special 3', planType: 'S'},
    ],

    // Contrato
    contractNumber: '',
    contractStatus: '',
    contractSignatureDate: '',
    contractLastChangeDate: '',
    contractValidityDate: '',

    contractAdjustmentConditions: '',
    contractLateFees: '',
    contractDocumentLink: '',
    contractObservation: '',

    // CRM
    crm: '',

    //
    headquarterCNPJ: '',
    belongs_to_group: false,
    is_branch: false,
  },
  history,
}) => {
  const classes = useStyles();
  const editing = !!business.id;
  const [errors, setErrors] = useState({});
  const [isBranch, setIsBranch] = useState(business.is_branch);
  const [belongsToGroup, setBelongsToGroup] = useState(
    business.belongs_to_group,
  );
  const [allEmpresas, setEmpresas] = useState([]);
  const [body, setBody] = useState(
    business.crm || `<p>Adicione a observação</p>`,
  );
  const [getUser, setUser] = useReduxState({
    loading: false,
  });
  const {enqueueSnackbar} = useSnackbar();

  const onSubmit = async form => {
    let stringifiedCompanies = '';
    if (form?.groupCompanies && form?.groupCompanies?.length > 0) {
      const formattedCompanies = form.groupCompanies.map(item => ({
        id: item.id,
        corporateName: item.corporateName,
      }));
      stringifiedCompanies = JSON.stringify(formattedCompanies, null, 2); // com identação bonitinha
    }

    const payload = {
      ...form,
      street: form.address.street,
      number: form.address.number,
      complement: form.address.complement,
      neighborhood: form.address.neighborhood,
      city: form.address.city,
      state: form.address.state,
      country: form.address.country,
      postalCode: form.address.postalCode,
      collaborators: form.contacts,
      contractSignatureDate: formatDate(form.contractSignatureDate),
      contractLastChangeDate: form.contractLastChangeDate,
      contractValidityDate: form.contractValidityDate,
      createdAt: formatDate(form.createdAt),
      updatedAt: formatDate(form.updatedAt),
      plans: form.plans,
      headquarter_cnpj: form.headquarterCNPJ,
      belongs_to_group: form?.groupCompanies?.length > 0 && belongsToGroup,
      is_branch: isBranch && !!form.headquarterCNPJ,
      group_companies: stringifiedCompanies,
    };

    setUser({loading: true});

    try {
      if (editing) {
        console.log(payload.plans);
        await api.put(`/business/${form.id}`, payload).then(res => {
          // console.log(res);
          if (res.status === 200) {
            enqueueSnackbar('Dados alterados com sucesso!');
            history.push('/empresas');
          }
        });
      } else {
        await api.post(`/business`, payload).then(res => {
          // console.log(res);
          if (res.status === 200) {
            enqueueSnackbar('Nova empresa cadastrada com sucesso!');
            history.push('/empresas');
          }
        });
      }
    } catch ({response}) {
      enqueueSnackbar(
        response.data.message ||
          'Ocorreu um erro ao cadastrar empresa. Tente novamente.',
      );
      setUser({loading: false});
    }
  };

  const BusinessFormEffectHandler = ({formik}) => {
    useEffect(() => {
      const error = formik.errors;
      const hasRegisterError =
        !!error.clientCode ||
        !!error.corporateName ||
        !!error.tradeName ||
        !!error.clientDocument ||
        !!error.address ||
        !!error.clientType ||
        !!error.customerSize ||
        !!error.activityBranch;

      const hasContractError =
        !!error.contractNumber ||
        !!error.contractStatus ||
        !!error.contractSignatureDate ||
        !!error.contractLastChangeDate ||
        !!error.contractValidityDate;

      const hasPaymentError =
        !!error.paymentMethod || !!error.billingType || !!error.billingStatus;

      setErrors(prev => {
        if (prev.register !== hasRegisterError) {
          return {
            ...prev,
            register: hasRegisterError,
            contacts: !!error.contacts,
            contract: hasContractError,
            payment: hasPaymentError,
            crm: !!error.crm,
          };
        }
        return prev;
      });
    }, [formik.errors]);

    return null;
  };

  const fetchEmpresa = async () => {
    try {
      const getAllEmpresas = await Business.findAll();
      setEmpresas(getAllEmpresas.filter(({id}) => id !== business.id));
    } catch (e) {
      // console.log({e});
    }
  };

  useEffect(() => {
    fetchEmpresa();
  }, []);

  return (
    <Formik
      initialValues={business}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={values => {
        onSubmit(values);
      }}>
      {formikProps => (
        <>
          <BusinessFormEffectHandler formik={formikProps} />
          <Grid container xs={12}>
            <Grid item xs={12} alignContent="center">
              <Typography component="h1" variant="h5">
                <ReturnButton />
                {editing ? 'Editar Empresa' : 'Cadastrar Nova Empresa'}
              </Typography>
            </Grid>

            <Grid item xs={12} md={12} lg={12} sx={{gap: 1}}>
              {!getUser().loading ? (
                <form onSubmit={formikProps.handleSubmit}>
                  <AccordionCustom
                    defaultExpanded={true}
                    title="Dados cadastrais"
                    errors={errors.register}
                    children={
                      <Grid container spacing={2}>
                        {editing && (
                          <>
                            {/* Código do Cliente */}
                            <Grid item xs={12} sm={6} md={3}>
                              <TextField
                                fullWidth
                                margin="none"
                                variant="outlined"
                                id="clientCode"
                                name="clientCode"
                                label="Código do Cliente"
                                value={formikProps.values.clientCode}
                                onChange={formikProps.handleChange}
                                helperText={
                                  formikProps.touched.clientCode &&
                                  formikProps.errors.clientCode
                                }
                                error={
                                  formikProps.touched.clientCode &&
                                  Boolean(formikProps.errors.clientCode)
                                }
                                disabled
                              />
                            </Grid>

                            {/* Status do cliente */}
                            <Grid item xs={12} sm={6} md={2}>
                              <TextField
                                select
                                fullWidth
                                disabled
                                variant="outlined"
                                label="Status do Cliente"
                                id="clientStatus"
                                name="clientStatus"
                                value={formikProps.values.clientStatus || '-'}
                                onChange={formikProps.handleChange}
                                helperText={
                                  formikProps.touched.clientStatus &&
                                  formikProps.errors.clientStatus
                                }
                                error={
                                  formikProps.touched.clientStatus &&
                                  Boolean(formikProps.errors.clientStatus)
                                }>
                                {[
                                  'Pesquisa',
                                  'Em prospecção',
                                  'Não houve interesse',
                                  'Proposta enviada',
                                  'Em negociação',
                                  'Proposta recusada',
                                  'Contrato ativo',
                                  'Em suspenso',
                                  'Inativo',
                                ].map(option => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          </>
                        )}

                        {/* Razão Social ou Nome Completo */}
                        <Grid item xs={12} sm={6} md={7}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="corporateName"
                            name="corporateName"
                            label="Razão Social / Nome Completo *"
                            value={formikProps.values.corporateName}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.corporateName &&
                              formikProps.errors.corporateName
                            }
                            error={
                              formikProps.touched.corporateName &&
                              Boolean(formikProps.errors.corporateName)
                            }
                          />
                        </Grid>

                        {/* Nome Fantasia */}
                        <Grid item xs={12} sm={6} md={6}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="tradeName"
                            name="tradeName"
                            label="Nome Fantasia *"
                            value={formikProps.values.tradeName}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.tradeName &&
                              formikProps.errors.tradeName
                            }
                            error={
                              formikProps.touched.tradeName &&
                              Boolean(formikProps.errors.tradeName)
                            }
                          />
                        </Grid>

                        {/* CPF ou CNPJ */}
                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="clientDocument"
                            name="clientDocument"
                            label="CNPJ ou CPF *"
                            value={formikProps.values.clientDocument}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.clientDocument &&
                              formikProps.errors.clientDocument
                            }
                            error={
                              formikProps.touched.clientDocument &&
                              Boolean(formikProps.errors.clientDocument)
                            }
                          />
                        </Grid>

                        {/* PORTE DO CLIENTE */}
                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            fullWidth
                            select
                            margin="none"
                            variant="outlined"
                            id="customerSize"
                            name="customerSize"
                            label="Porte do Cliente *"
                            value={formikProps.values.customerSize}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.customerSize &&
                              formikProps.errors.customerSize
                            }
                            error={
                              formikProps.touched.customerSize &&
                              Boolean(formikProps.errors.customerSize)
                            }>
                            {['Micro', 'Pequeno', 'Médio', 'Grande'].map(
                              type => (
                                <MenuItem key={type} value={type}>
                                  {type}
                                </MenuItem>
                              ),
                            )}
                          </TextField>
                        </Grid>

                        {/* Endereço */}
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.postalCode"
                            name="address.postalCode"
                            label="CEP *"
                            value={formikProps.values.address.postalCode || ''}
                            onChange={e => {
                              const cep = e.target.value;
                              getviaCepUrl(cep, formikProps);
                              formikProps.setFieldValue(
                                'address.postalCode',
                                cep,
                              );
                              formikProps.setFieldError(
                                'address.postalCode',
                                '',
                              );
                            }}
                            helperText={
                              getIn(
                                formikProps.touched,
                                'address.postalCode',
                              ) &&
                              getIn(formikProps.errors, 'address.postalCode')
                            }
                            error={
                              getIn(
                                formikProps.touched,
                                'address.postalCode',
                              ) &&
                              Boolean(
                                getIn(formikProps.errors, 'address.postalCode'),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={8} md={8}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.street"
                            name="address.street"
                            label="Logradouro *"
                            value={formikProps.values.address.street}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(formikProps.touched, 'address.street') &&
                              getIn(formikProps.errors, 'address.street')
                            }
                            error={
                              getIn(formikProps.touched, 'address.street') &&
                              Boolean(
                                getIn(formikProps.errors, 'address.street'),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={4} md={2}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.number"
                            name="address.number"
                            label="Número *"
                            value={formikProps.values.address.number}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(formikProps.touched, 'address.number') &&
                              getIn(formikProps.errors, 'address.number')
                            }
                            error={
                              getIn(formikProps.touched, 'address.number') &&
                              Boolean(
                                getIn(formikProps.errors, 'address.number'),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.complement"
                            name="address.complement"
                            label="Complemento"
                            value={formikProps.values.address.complement}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(
                                formikProps.touched,
                                'address.complement',
                              ) &&
                              getIn(formikProps.errors, 'address.complement')
                            }
                            error={
                              getIn(
                                formikProps.touched,
                                'address.complement',
                              ) &&
                              Boolean(
                                getIn(formikProps.errors, 'address.complement'),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.neighborhood"
                            name="address.neighborhood"
                            label="Bairro *"
                            value={formikProps.values.address.neighborhood}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(
                                formikProps.touched,
                                'address.neighborhood',
                              ) &&
                              getIn(formikProps.errors, 'address.neighborhood')
                            }
                            error={
                              getIn(
                                formikProps.touched,
                                'address.neighborhood',
                              ) &&
                              Boolean(
                                getIn(
                                  formikProps.errors,
                                  'address.neighborhood',
                                ),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.city"
                            name="address.city"
                            label="Cidade *"
                            value={formikProps.values.address.city}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(formikProps.touched, 'address.city') &&
                              getIn(formikProps.errors, 'address.city')
                            }
                            error={
                              getIn(formikProps.touched, 'address.city') &&
                              Boolean(getIn(formikProps.errors, 'address.city'))
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={1}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.state"
                            name="address.state"
                            label="Estado *"
                            value={formikProps.values.address.state}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(formikProps.touched, 'address.state') &&
                              getIn(formikProps.errors, 'address.state')
                            }
                            error={
                              getIn(formikProps.touched, 'address.state') &&
                              Boolean(
                                getIn(formikProps.errors, 'address.state'),
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={1}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="address.country"
                            name="address.country"
                            label="País *"
                            value={formikProps.values.address.country}
                            onChange={formikProps.handleChange}
                            helperText={
                              getIn(formikProps.touched, 'address.country') &&
                              getIn(formikProps.errors, 'address.country')
                            }
                            error={
                              getIn(formikProps.touched, 'address.country') &&
                              Boolean(
                                getIn(formikProps.errors, 'address.country'),
                              )
                            }
                          />
                        </Grid>

                        {/* Tipo de Cliente */}
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            select
                            margin="none"
                            variant="outlined"
                            id="clientType"
                            name="clientType"
                            label="Tipo de Cliente *"
                            value={formikProps.values.clientType}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.clientType &&
                              formikProps.errors.clientType
                            }
                            error={
                              formikProps.touched.clientType &&
                              Boolean(formikProps.errors.clientType)
                            }>
                            {[
                              'Corporativo',
                              'Indústria',
                              'Comércio',
                              'ONG/OCIP',
                              'Associação',
                            ].map(type => (
                              <MenuItem key={type} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        {/* Ramo de Atividade */}
                        <Grid item xs={12} sm={6} md={8}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="activityBranch"
                            name="activityBranch"
                            label="Ramo de Atividade *"
                            value={formikProps.values.activityBranch}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.activityBranch &&
                              formikProps.errors.activityBranch
                            }
                            error={
                              formikProps.touched.activityBranch &&
                              Boolean(formikProps.errors.activityBranch)
                            }
                          />
                        </Grid>

                        {/* Checkbox: Empresa Filial */}
                        <Grid item xs={12} sm={6} md={isBranch ? 4 : 12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isBranch}
                                onChange={e => {
                                  setIsBranch(e.target.checked);
                                  if (!e.target.checked) {
                                    formikProps.setFieldValue(
                                      'headquarterCNPJ',
                                      '',
                                    );
                                  }
                                }}
                                name="isBranch"
                                color="primary"
                              />
                            }
                            label="Empresa Filial"
                          />
                        </Grid>

                        {/* Campo CNPJ da Matriz (exibido se marcado) */}
                        {isBranch && (
                          <Grid item xs={12} sm={6} md={8}>
                            <TextField
                              fullWidth
                              margin="none"
                              variant="outlined"
                              id="headquarterCNPJ"
                              name="headquarterCNPJ"
                              label="CNPJ da Matriz"
                              value={formikProps.values.headquarterCNPJ}
                              onChange={formikProps.handleChange}
                              helperText={
                                formikProps.touched.headquarterCNPJ &&
                                formikProps.errors.headquarterCNPJ
                              }
                              error={
                                formikProps.touched.headquarterCNPJ &&
                                Boolean(formikProps.errors.headquarterCNPJ)
                              }
                            />
                          </Grid>
                        )}

                        {/* Checkbox: Empresa pertencente a grupo */}
                        <Grid item xs={12} sm={6} md={belongsToGroup ? 4 : 12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={belongsToGroup}
                                onChange={e => {
                                  setBelongsToGroup(e.target.checked);
                                  if (!e.target.checked) {
                                    formikProps.setFieldValue(
                                      'groupCompanies',
                                      [],
                                    );
                                  }
                                }}
                                name="belongsToGroup"
                                color="primary"
                              />
                            }
                            label="Empresa pertencente a grupo"
                          />
                          {/* Lista das empresas selecionadas ordenadas */}
                          {belongsToGroup &&
                            formikProps.values.groupCompanies &&
                            formikProps.values.groupCompanies.length > 0 && (
                              <Grid item xs={12}>
                                <ul>
                                  {formikProps.values.groupCompanies
                                    .slice()
                                    .sort((a, b) =>
                                      a.corporateName.localeCompare(
                                        b.corporateName,
                                      ),
                                    )
                                    .map(company => (
                                      <li key={company.id}>
                                        {company.corporateName}
                                      </li>
                                    ))}
                                </ul>
                              </Grid>
                            )}
                        </Grid>

                        {/* Dropdown multiselect (Empresas do grupo) */}
                        {belongsToGroup && (
                          <Grid item xs={12} sm={6} md={8}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel
                                id="groupCompanies-label"
                                style={{
                                  backgroundColor: 'white',
                                  paddingLeft:
                                    formikProps?.values?.groupCompanies
                                      ?.length > 0
                                      ? 5
                                      : 0,
                                  paddingRight: 5,
                                }}>
                                Empresas do grupo
                              </InputLabel>
                              <Select
                                labelId="groupCompanies-label"
                                id="groupCompanies"
                                name="groupCompanies"
                                multiple
                                value={
                                  formikProps.values.groupCompanies?.map(
                                    e => e.id,
                                  ) || []
                                }
                                onChange={e => {
                                  const selectedIds = e.target.value;

                                  const selectedCompanies = allEmpresas.filter(
                                    empresa => selectedIds.includes(empresa.id),
                                  );

                                  formikProps.setFieldValue(
                                    'groupCompanies',
                                    selectedCompanies,
                                  );
                                }}
                                renderValue={selectedIds =>
                                  allEmpresas
                                    .filter(empresa =>
                                      selectedIds.includes(empresa.id),
                                    )
                                    .map(empresa => empresa.corporateName)
                                    .join(', ')
                                }>
                                {allEmpresas.map(empresa => (
                                  <MenuItem key={empresa.id} value={empresa.id}>
                                    <Checkbox
                                      checked={formikProps.values.groupCompanies?.some(
                                        e => e.id === empresa.id,
                                      )}
                                    />
                                    <ListItemText
                                      primary={empresa.corporateName}
                                    />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        )}

                        {/* Site */}
                        <Grid item xs={12} sm={6} md={8}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="site"
                            name="site"
                            label="Site"
                            value={formikProps.values.site}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.site &&
                              formikProps.errors.site
                            }
                            error={
                              formikProps.touched.site &&
                              Boolean(formikProps.errors.site)
                            }
                          />
                        </Grid>

                        {/* Mídia 1 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="midia_1"
                            name="midia_1"
                            label="Mídia Social 1"
                            value={formikProps.values.midia_1}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.midia_1 &&
                              formikProps.errors.midia_1
                            }
                            error={
                              formikProps.touched.midia_1 &&
                              Boolean(formikProps.errors.midia_1)
                            }
                          />
                        </Grid>

                        {/* Mídia 2 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="midia_2"
                            name="midia_2"
                            label="Mídia Social 2"
                            value={formikProps.values.midia_2}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.midia_2 &&
                              formikProps.errors.midia_2
                            }
                            error={
                              formikProps.touched.midia_2 &&
                              Boolean(formikProps.errors.midia_2)
                            }
                          />
                        </Grid>

                        {/* Mídia 3 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="midia_3"
                            name="midia_3"
                            label="Mídia Social 3"
                            value={formikProps.values.midia_3}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.midia_3 &&
                              formikProps.errors.midia_3
                            }
                            error={
                              formikProps.touched.midia_3 &&
                              Boolean(formikProps.errors.midia_3)
                            }
                          />
                        </Grid>

                        {/* Mídia 4 */}
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="midia_4"
                            name="midia_4"
                            label="Mídia Social 4"
                            value={formikProps.values.midia_4}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.midia_4 &&
                              formikProps.errors.midia_4
                            }
                            error={
                              formikProps.touched.midia_4 &&
                              Boolean(formikProps.errors.midia_4)
                            }
                          />
                        </Grid>

                        {/* Observação */}
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            margin="none"
                            variant="outlined"
                            id="clientObservation"
                            name="clientObservation"
                            label="Observações"
                            value={formikProps.values.clientObservation}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.clientObservation &&
                              formikProps.errors.clientObservation
                            }
                            error={
                              formikProps.touched.clientObservation &&
                              Boolean(formikProps.errors.clientObservation)
                            }
                          />
                        </Grid>
                      </Grid>
                    }
                  />

                  <AccordionCustom
                    title="Contatos"
                    errors={formikProps.errors.contacts}
                    children={
                      <Grid item xs={12}>
                        <FieldArray
                          name="contacts"
                          render={arrayHelpers => (
                            <>
                              {formikProps.values.contacts.map(
                                (contact, index) => (
                                  <AccordionItem
                                    key={index}
                                    formikProps={formikProps}
                                    errors={formikProps.errors?.contacts}
                                    contact={contact}
                                    index={index}
                                    onRemove={() => arrayHelpers.remove(index)}
                                  />
                                ),
                              )}

                              <Button
                                onClick={() => {
                                  if (formikProps.values.contacts.length <= 4) {
                                    arrayHelpers.push({
                                      name: '',
                                      nickname: '',
                                      department: '',
                                      role: '',
                                      phone1: '',
                                      phone2: '',
                                      whatsapp: '',
                                      email: '',
                                      emailLogin: '',
                                      cpf: '',
                                      rg: '',
                                      street: '',
                                      number: null,
                                      neighborhood: '',
                                      city: '',
                                      state: '',
                                      country: '',
                                      postalCode: '',
                                      contactObservation: '',
                                    });
                                  }
                                }}>
                                Adicionar Contato
                              </Button>

                              {getIn(formikProps.touched, 'contacts') &&
                                getIn(formikProps.errors, 'contacts') &&
                                typeof getIn(formikProps.errors, 'contacts') ===
                                  'string' && (
                                  <FormHelperText error style={{marginTop: 8}}>
                                    {getIn(formikProps.errors, 'contacts')}
                                  </FormHelperText>
                                )}
                            </>
                          )}
                        />
                      </Grid>
                    }
                  />

                  <AccordionCustom
                    title="Contrato"
                    errors={errors.contract}
                    children={
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                          <TextField
                            fullWidth
                            type="text"
                            margin="none"
                            variant="outlined"
                            id="contractNumber"
                            name="contractNumber"
                            label="Número do contrato *"
                            value={formikProps.values.contractNumber}
                            onChange={e => {
                              const value = e.target.value.replace(/\D/g, '');
                              formikProps.setFieldValue(
                                'contractNumber',
                                value,
                              );
                            }}
                            inputProps={{maxLength: 5}}
                            helperText={
                              formikProps.touched.contractNumber &&
                              formikProps.errors.contractNumber
                            }
                            error={
                              formikProps.touched.contractNumber &&
                              Boolean(formikProps.errors.contractNumber)
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <TextField
                            select
                            fullWidth
                            margin="none"
                            variant="outlined"
                            id="contractStatus"
                            name="contractStatus"
                            label="Status do contrato *"
                            value={formikProps.values.contractStatus}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractStatus &&
                              formikProps.errors.contractStatus
                            }
                            error={
                              formikProps.touched.contractStatus &&
                              Boolean(formikProps.errors.contractStatus)
                            }>
                            {[
                              'Em negociação',
                              'Com pendência',
                              'Ativo',
                              'Rescindido',
                            ].map(option => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            type="date"
                            id="contractSignatureDate"
                            name="contractSignatureDate"
                            label="Data da assinatura *"
                            InputLabelProps={{shrink: true}}
                            value={formatDate(
                              formikProps.values.contractSignatureDate,
                            )}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractSignatureDate &&
                              formikProps.errors.contractSignatureDate
                            }
                            error={
                              formikProps.touched.contractSignatureDate &&
                              Boolean(formikProps.errors.contractSignatureDate)
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            type="date"
                            id="contractValidityDate"
                            name="contractValidityDate"
                            label="Vigência do contrato *"
                            InputLabelProps={{shrink: true}}
                            value={formikProps.values.contractValidityDate}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractValidityDate &&
                              formikProps.errors.contractValidityDate
                            }
                            error={
                              formikProps.touched.contractValidityDate &&
                              Boolean(formikProps.errors.contractValidityDate)
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            type="date"
                            id="contractLastChangeDate"
                            name="contractLastChangeDate"
                            label="Data da última alteração *"
                            InputLabelProps={{shrink: true}}
                            value={formikProps.values.contractLastChangeDate}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractLastChangeDate &&
                              formikProps.errors.contractLastChangeDate
                            }
                            error={
                              formikProps.touched.contractLastChangeDate &&
                              Boolean(formikProps.errors.contractLastChangeDate)
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            multiline
                            minRows={3}
                            id="contractAdjustmentConditions"
                            name="contractAdjustmentConditions"
                            label="Condições de Reajuste"
                            value={
                              formikProps.values.contractAdjustmentConditions
                            }
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched
                                .contractAdjustmentConditions &&
                              formikProps.errors.contractAdjustmentConditions
                            }
                            error={
                              formikProps.touched
                                .contractAdjustmentConditions &&
                              Boolean(
                                formikProps.errors.contractAdjustmentConditions,
                              )
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            multiline
                            minRows={3}
                            id="contractLateFees"
                            name="contractLateFees"
                            label="Encargos por atraso"
                            value={formikProps.values.contractLateFees}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractLateFees &&
                              formikProps.errors.contractLateFees
                            }
                            error={
                              formikProps.touched.contractLateFees &&
                              Boolean(formikProps.errors.contractLateFees)
                            }
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            minRows={3}
                            margin="none"
                            variant="outlined"
                            id="contractDocumentLink"
                            name="contractDocumentLink"
                            label="Link do contrato digitalizado"
                            value={formikProps.values.contractDocumentLink}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractDocumentLink &&
                              formikProps.errors.contractDocumentLink
                            }
                            error={
                              formikProps.touched.contractDocumentLink &&
                              Boolean(formikProps.errors.contractDocumentLink)
                            }
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            multiline
                            minRows={3}
                            id="contractObservation"
                            name="contractObservation"
                            label="Observações"
                            value={formikProps.values.contractObservation}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.contractObservation &&
                              formikProps.errors.contractObservation
                            }
                            error={
                              formikProps.touched.contractObservation &&
                              Boolean(formikProps.errors.contractObservation)
                            }
                          />
                        </Grid>
                      </Grid>
                    }
                  />

                  <AccordionCustom
                    title="Comercial - Planos"
                    children={
                      <Grid container spacing={1}>
                        {/* STATUS DO CLIENTE */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          style={{marginTop: 10}}>
                          <TextField
                            select
                            fullWidth
                            variant="outlined"
                            label="Status do Cliente"
                            id="clientStatus"
                            name="clientStatus"
                            value={formikProps.values.clientStatus}
                            onChange={formikProps.handleChange}
                            helperText={
                              formikProps.touched.clientStatus &&
                              formikProps.errors.clientStatus
                            }
                            error={
                              formikProps.touched.clientStatus &&
                              Boolean(formikProps.errors.clientStatus)
                            }>
                            {[
                              'Pesquisa',
                              'Em prospecção',
                              'Não houve interesse',
                              'Proposta enviada',
                              'Em negociação',
                              'Proposta recusada',
                              'Contrato ativo',
                              'Em suspenso',
                              'Inativo',
                            ].map(option => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>

                        <Grid item xs={12}>
                          {/* <FieldArray
                            name="plans"
                            render={arrayHelpers => (
                              <>
                                {formikProps.values.plans.map(
                                  (plans, index) => (
                                    <AccordionItemPlans
                                      key={index}
                                      formikProps={formikProps}
                                      errors={formikProps.errors?.plans}
                                      plans={plans}
                                      index={index}
                                      onRemove={() =>
                                        arrayHelpers.remove(index)
                                      }
                                    />
                                  ),
                                )}

                                <Button
                                  onClick={() => {
                                    if (formikProps.values.plans.length <= 3) {
                                      arrayHelpers.push({
                                        planType: '',
                                        beneficiaryType: '',
                                        commercialNotes: '',
                                        additionalServices: '',
                                        date: '',
                                        value: '',
                                        discount: '',
                                        validity: '',
                                      });
                                    }
                                  }}>
                                  Adicionar Plano
                                </Button>

                                {getIn(formikProps.touched, 'plans') &&
                                  getIn(formikProps.errors, 'plans') &&
                                  typeof getIn(formikProps.errors, 'plans') ===
                                    'string' && (
                                    <FormHelperText
                                      error
                                      style={{marginTop: 8}}>
                                      {getIn(formikProps.errors, 'plans')}
                                    </FormHelperText>
                                  )}
                              </>
                            )}
                          /> */}

                          <PlansForm
                            formikProps={formikProps}
                            errors={errors}
                          />
                        </Grid>
                      </Grid>
                    }
                  />

                  <AccordionCustom
                    title="CRM"
                    errors={errors.crm}
                    children={
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <div style={{marginBottom: '10px'}} />
                          <EditorComponent
                            body={body}
                            setBody={setBody}
                            setFormBody={e => {
                              formikProps.setFieldValue('crm', e);
                            }}
                          />
                        </Grid>
                      </Grid>
                    }
                  />

                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                    }}>
                    <ButtonSubmit
                      style={{
                        marginTop: 30,
                        width: '20vw',
                        alignSelf: 'center',
                      }}
                      type="submit"
                      variant="contained"
                      color="primary">
                      {editing ? 'Salvar' : 'Cadastrar'}
                    </ButtonSubmit>
                  </div>
                </form>
              ) : (
                <div
                  className="flex-col center-a center-b"
                  style={{height: '50vh'}}>
                  <CircularProgress size={100} />
                  <p> Carregando... </p>
                </div>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </Formik>
  );
};

export default BusinessForm;